export const SELL_ONLY_MINE = 'SELL_ONLY_MINE';
export const SELL_ALL = 'SELL_ALL';
export const SELL_TICKET = 'SELL_TICKET';